<template>
<DashboardPanelTemplate
  :panelSize="panelSize"
  :panelFocus="panelFocus"
  :loading="loading">
  <div class="panel-header">{{$t('Header')}}</div>
  <p class="text-content">{{$t('Content1')}}</p>
  <p class="text-content">{{$t('Content2')}}</p>
  <div class="dhruv">
    <p class="name">{{$t('DhruvName')}}</p>
    <p class="title">{{$t('DhruvTitle')}}</p>
  </div>
</DashboardPanelTemplate>
</template>
<script>
import DashboardPanelTemplate from '../../layouts/DashboardPanelTemplate'
export default {
  name: 'WelcomeSetupPanel',
  props: {
    panelSize: {
      type: String,
      required: true
    },
    panelFocus: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    DashboardPanelTemplate
  },
  i18n: {
    messages: {
      'en-US': {
        Header: 'A Message From Our Founder',
        Content1: `On behalf of our entire team, welcome to ShipBob! Our mission is to help e-commerce \
          sellers be more successful online, and we're accomplishing that by providing easy, affordable \
          fulfillment.`,
        Content2: `Please let us know how we can help you during your entrepreneurial journey!`,
        DhruvName: 'Dhruv Saxena',
        DhruvTitle: 'Co-Founder & CEO'
      },
      'de': {
        Header: 'Herzlich Willkommen!',
        Content1: `Im Namen unseres Teams, willkommen bei Shipbob! Unsere Mission ist E-Commerce-Verkäufer zu helfen, um \
          erfolgreicher Online zu werden. Wir schaffen das durch einfaches, billiges Fulfillment zu versorgen. Bitte geben \
          Sie uns Bescheid, wie wir Ihnen während Ihrer Unternehmerreise helfen können!`,
        Content2: `Bitte geben Sie uns Bescheid, wie wir Ihnen während Ihrer Unternehmerreise helfen können!`
      }
    }
  }
}

</script>
<style scoped lang='scss'>
@import '../../../../assets/scss/shipbob-custom/components/dashboard/_setup-panel-welcome.scss';
@import '../../../../assets/scss/shipbob-custom/components/dashboard/_setup-panel-tools.scss';
</style>